import { Trans } from "@lingui/macro";
import { IApiEpBillingTokenPackage } from "@smp/api";
import { UiBox } from "@smp/ui";

export * from "./composition_token_package";

export const CompositionTokenPackage = ({
  productTokenPackage,
}: {
  productTokenPackage: IApiEpBillingTokenPackage;
}) => (
  <UiBox display="flex" flexDirection="row">
    <UiBox flexGrow={1} pl={2}>
      <Trans>Quantity</Trans>
    </UiBox>
    <UiBox flexGrow={1} textAlign="right">
      {productTokenPackage.amount}
    </UiBox>
  </UiBox>
);
